import ClientProfilePage from './clientProfile';

export default ClientProfilePage;


// WEBPACK FOOTER //
// ./src/features/client-profile/pages/client-profile-page/index.js